import { Box, Card, CardBody, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ExpenseCard = ({
  title = "",
  percentage = "-",
  total = "-",
  perfectPL = "-",
  color = "black",
  p = null,
  type = "",
  clickable = true,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleClick = () => {
    if (type) {
      navigate(`/lucro-metrics/${type}/${"growth"}`, {
        state: { from: location.pathname },
      });
    }
  };
  return (
    <Stack
      width="100%"
      align="center"
      p={p ? p : "10px 10px"}
      fontFamily={"lato"}
    >
      <Card
        width="100%"
        height="143px"
        borderRadius="12px"
        onClick={handleClick}
        _hover={clickable && { boxShadow: "xl", cursor: "pointer" }}
      >
        <CardBody padding={"12px"}>
          <Box align={"center"} p={0}>
            <Text fontSize={"16px"} margin={0} p={0} color={"#202224"}>
              {title}
            </Text>
            <Text
              fontSize={"clamp(28px, 5vw, 32px)"}
              fontWeight={600}
              margin={0}
              p={0}
              color={color}
            >
              {percentage}
            </Text>
          </Box>
          <Box height={"30px"}>
            <SimpleGrid templateColumns={"1fr 1fr"} align="center">
              <Box p={0} borderRightWidth={"2px"} height={"100%"} m={0}>
                <Text
                  fontSize={"14px"}
                  margin={0}
                  gridColumn={1}
                  gridRow={1}
                  color={"#202224"}
                >
                  Perfect P&L
                </Text>
                <Text
                  fontSize={"clamp(12px, 5vw, 17px)"}
                  fontWeight={600}
                  margin={0}
                  gridColumn={1}
                  gridRow={2}
                  whiteSpace={"nowrap"}
                >
                  {perfectPL === "No Target" ? "No Target" : `Below ${perfectPL}`}
                </Text>
              </Box>
              <Box p={0}>
                <Text
                  fontSize={"14px"}
                  margin={0}
                  gridColumn={2}
                  gridRow={1}
                  color={"#202224"}
                >
                  Total
                </Text>
                <Text
                  fontSize={"clamp(12px, 5vw, 17px)"}
                  fontWeight={600}
                  margin={0}
                  gridColumn={2}
                  gridRow={2}
                  whiteSpace={"nowrap"}
                >
                  {total}
                </Text>
              </Box>
            </SimpleGrid>
          </Box>
        </CardBody>
      </Card>
    </Stack>
  );
};

export default ExpenseCard;
